import { useSelector } from 'react-redux';
import {
  ACCOUNT_TYPE_CORPORATE_TRUST,
  APPLICATION_TYPE_CORPORATE,
  APPLICATION_TYPE_INDIVIDUAL,
  APPLICATION_TYPE_IRA,
  APPLICATION_TYPE_JOINT_TENANTS,
  APPLICATION_TYPE_UTMA,
} from '../constants/accountTypes';
import { selectApplicationType } from '../store/selectors/applicationSelectors';
import { APPLICATION_TYPE_STRING_KEYS } from '../util/constants';
import useTrackingDetails from './useTrackingDetails';

const useChoosenApplicationTypeData = () => {
  const { ApplicationType, AccountType } = useSelector(selectApplicationType);
  const { TrackingDetails } = useTrackingDetails();

  if (!ApplicationType && AccountType) {
    return;
  }
  const corporateApplicationType = () => {
    if (AccountType === ACCOUNT_TYPE_CORPORATE_TRUST)
      return {
        ApplicationType: APPLICATION_TYPE_CORPORATE,
        CorporateAccountType: ACCOUNT_TYPE_CORPORATE_TRUST,
        TrackingDetails,
      };
    return {
      ApplicationType: APPLICATION_TYPE_CORPORATE,
      TrackingDetails,
    };
  };
  const applicationTypeData = () => {
    switch (ApplicationType) {
      case APPLICATION_TYPE_STRING_KEYS.Individual:
        return {
          ApplicationType: APPLICATION_TYPE_INDIVIDUAL,
          TrackingDetails,
        };
      case APPLICATION_TYPE_STRING_KEYS.Corporate:
        return corporateApplicationType();
      case APPLICATION_TYPE_STRING_KEYS.IRA:
        return {
          ApplicationType: APPLICATION_TYPE_IRA,
          IRAAccountType: AccountType,
          TrackingDetails,
        };
      case APPLICATION_TYPE_STRING_KEYS.JointTenants:
        return {
          ApplicationType: APPLICATION_TYPE_JOINT_TENANTS,
          TrackingDetails,
        };
      case APPLICATION_TYPE_STRING_KEYS.UTMA:
        return {
          ApplicationType: APPLICATION_TYPE_UTMA,
          UTMAAccountType: AccountType,
          TrackingDetails,
        };

      default:
        return {
          ApplicationType: APPLICATION_TYPE_INDIVIDUAL,
          TrackingDetails,
        };
    }
  };

  const data = applicationTypeData();

  return { data };
};

export default useChoosenApplicationTypeData;
